module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/logo-aoj-zh-hant-50b84c495baeb207165ea731bc1495b5.svg";